// extracted by mini-css-extract-plugin
export default {"wrapper":"ClanBattles-module_wrapper_a772a","tabsNavigation":"ClanBattles-module_tabsNavigation_c5fd4","tabs":"ClanBattles-module_tabs_bb45f"};